// removed by extract-text-webpack-plugin
module.exports = {"userPicture":"SfW9CtoQRrHnfMhb83oEE","ulContainer":"_1IDwn8fbide1APplgJpTjf","btnLogin":"_36mW12qgi69Y54Fh4E_blz","btnGoogle":"_1estDz9PeHY31c6OkJJ_mo","btnFacebook":"_3-1f97-pQb1dmfmThjLRsu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logins/LoginMenu.scss
// module id = 186
// module chunks = 0